import React from "react";
import { useAppSelector } from "../../../store/index.ts";
import ChatBottomFixed from "./ChatBottomFixed.jsx";

export default function ChatBottomFixedController({
  ChatSendRef,
  className,
  ChatSendSendRef,
  children,
}) {
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  // const isIphone = useAppSelector((state) => state.deviceSize.isIos);

  return isMobile ? (
    <ChatBottomFixed
      ChatSendRef={ChatSendRef}
      ChatSendSendRef={ChatSendSendRef}
      className={className}
    >
      {children}
    </ChatBottomFixed>
  ) : (
    <div className={className} ref={ChatSendSendRef}>
      {children}
    </div>
  );
}
